var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBreak = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "free_breakfast_black_24dp",
    viewBox: "0 0 14.938 14.938",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8361",
    "data-name": "Path 8361",
    d: "M0,0H14.938V14.938H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8362",
    "data-name": "Path 8362",
    d: "M13.959,3H5.245A1.249,1.249,0,0,0,4,4.245V9.224a2.489,2.489,0,0,0,2.49,2.49h3.735a2.489,2.489,0,0,0,2.49-2.49V7.357h1.245A1.245,1.245,0,0,0,15.2,6.112V4.245A1.249,1.249,0,0,0,13.959,3Zm0,3.112H12.714V4.245h1.245ZM4.622,12.959h8.714a.622.622,0,1,1,0,1.245H4.622a.622.622,0,0,1,0-1.245Z",
    transform: "translate(-1.51 -1.133)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBreak, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/break.88c7d27f.svg";
export { ForwardRef as ReactComponent };